module.exports = __webpack_public_path__ + "img/icon-question-checkbox.b9f8ff7c.svg";